import { useEffect, type ReactNode } from 'react';
import Message from 'carbon-react/lib/components/message';

type NotificationVariant = 'success' | 'error';

interface NotificationMessageProps {
  open: boolean;
  onDismiss: () => void;
  variant: NotificationVariant;
  timeout?: number;
  children: ReactNode;
}

export const NotificationMessage = ({
  open,
  onDismiss,
  variant,
  timeout = 3000,
  children,
}: NotificationMessageProps) => {
  useEffect(() => {
    if (!open || !timeout) return;
    const timer = window.setTimeout(onDismiss, timeout);
    return () => window.clearTimeout(timer);
  }, [open, timeout, onDismiss]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      <Message open={open} onDismiss={onDismiss} variant={variant}>
        {children}
      </Message>
    </div>
  );
};
